import { Link } from "react-router-dom";
import { MapPin, Phone, Scale } from "lucide-react";
import { BRAND, PHONE_TEL, PHONE_DISPLAY } from "@/lib/constants";
import SocialLinks from "@/components/SocialLinks";
import { BrandLogo } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <BrandLogo />
          <p className="mt-5 text-sm text-zinc-400 leading-relaxed max-w-xs">
            Achat, vente et revente de véhicules sélectionnés avec exigence à Chalon-sur-Saône.
            Chaque voiture est inspectée, reconditionnée et garantie.
          </p>
          <SocialLinks className="mt-6" />
        </div>

        <div className="text-sm text-zinc-400 space-y-3">
          <p className="font-spec text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4">Contact</p>
          <p className="flex items-start gap-2">
            <MapPin className="w-4 h-4 mt-0.5 text-[#FF1E27] shrink-0" />
            {BRAND.address}
          </p>
          <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-white transition-colors">
            <Phone className="w-4 h-4 text-[#FF1E27]" />
            {PHONE_DISPLAY}
          </a>
          <nav className="pt-4 flex flex-col gap-2">
            <Link to="/catalogue" data-testid="footer-catalog-link" className="hover:text-white transition-colors">Catalogue</Link>
            <Link to="/vendre" data-testid="footer-trade-in-link" className="hover:text-white transition-colors">Vendre ma voiture</Link>
            <Link to="/contact" data-testid="footer-contact-link" className="hover:text-white transition-colors">Contact</Link>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Espace Pro</Link>
          </nav>
        </div>

        <div className="text-xs text-zinc-500 space-y-2 leading-relaxed">
          <p className="font-spec text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4 flex items-center gap-2">
            <Scale className="w-4 h-4 text-[#FF1E27]" /> Mentions légales
          </p>
          <p>GROUPE HUVIG — SASU au capital social déclaré au RCS de Chalon-sur-Saône.</p>
          <p>Siège social : {BRAND.address}</p>
          <p>SIREN : {BRAND.siren} — RCS Chalon-sur-Saône</p>
          <p>N° TVA intracommunautaire : FR05100073378</p>
          <p>
            Médiateur de la consommation : CNPM — Médiation de la Consommation, 27 avenue de la
            Libération, 42400 Saint-Chamand — www.cnpm-mediation-consommation.eu
          </p>
          <p>
            Les données transmises via nos formulaires sont utilisées uniquement pour traiter votre
            demande, conformément au RGPD. Vous disposez d'un droit d'accès, de rectification et de
            suppression.
          </p>
        </div>
      </div>

      <div className="border-t border-white/5 py-6 text-center text-xs text-zinc-600 font-spec uppercase tracking-[0.25em]">
        © {new Date().getFullYear()} Groupe Huvig — Tous droits réservés
      </div>
    </footer>
  );
}
